export default {
    txt_welcome: 'ขอต้อนรับ',
    txt_dataover: 'คุณสมบัติทั้งหมด',
    txt_chance: 'โอกาส',
    txt_device: 'อุปกรณฺ',
    txt_chinese: '中文-Chinese',
    txt_english: '英文-English',
    txt_malay: '马来语-Malay',
    txt_reports: '检测记录',
    txt_setting: '设置',
    txt_dymanager: '店员管理',
    txt_account: '账号ID',
    txt_userstatus: '用户身份',
    txt_name: '姓名',
    txt_contactway: 'รายละเอียดการติดต่อ',
    txt_accountsafe: '账号安全',
    txt_basicinfo: '基本信息',
    txt_updatepassword: '修改密码',
    txt_storeinfomation: '门店信息',
    txt_storename: '门店名称',
    txt_storephone: '门店电话',
    txt_storeaddress: '门店地址',
    txt_AppInfomation: 'App信息',
    txt_currentversion: '当前版本',
    txt_software: '软件更新',
    txt_loginout: '退出登录',
    txt_updatelanguage: '语言设置',
    txt_updateto: '更新至',
    txt_zwgx: '暂无更新',
    txt_dz: '店长',
    txt_sh: '商户',
    txt_dy: '店员',
    txt_bdsj: '绑定手机',
    txt_shxx: '商户信息',
    txt_shname: '商户名称',
    txt_ssmd: '所属门店',
    txt_bdsb: '绑定设备',
    txt_mendian: '门店',


    //数据总览模块
    txt_sTime: '选择时间查询',
    txt_car_check: '查车率',
    txt_findchance: '发现机会',
    txt_trackchace: '机会跟踪',
    txt_transform: '转化率',
    txt_TotalData: '总体数据',
    txt_xxsj: '详细数据',
    txt_zhsj: '转化数据',
    txt_TireWear: '轮胎磨损',
    txt_DataHopper: '数据漏斗',
    txt_jdcc: '进店车次',
    txt_CheckCar: '查车数',
    txt_ChanceNum: '机会数',
    txt_TrackNum: '跟踪数',
    txt_TranseformNum: '转化数',
    txt_UnTrack: '未跟踪',
    txt_l: 'รถ',
    txt_Time: 'เวลา',
    txt_Device: 'อุปกรณ์',
    txt_car_plate: 'ป้ายทะเบียน',
    txt_Wear: 'การสึกหรอ',
    txt_Pwear: 'สึกหรอบางส่วน',
    txt_NoData: 'ไม่มีข้อมูล',
    txt_GoodState: 'ปกติ',
    txt_Border: 'ตำแหน่ง:',
    txt_replace: 'เปลี่ยนใหม่ทันที',
    txt_Total_Check: 'จำนวนรถที่ตรวจสอบทั้งหมด',
    txt_pmqk: 'สึกหรอบางส่วน',
    txt_LightWear: 'สึกหรอเล็กน้อย',
    txt_GraveWear: 'สึกหรอรุนแรง',
    txt_hwtj: '换位统计',
    txt_wxhw: '无需换位',
    txt_xyhw: '需要换位',
    txt_jcxq: '检测详情',
    txt_zhxq: '转化详情',
    txt_cc: 'รถ',
    txt_bfb: '%',
    txt_ltxs: '轮胎销售',
    txt_sldw: '四轮定位',
    txt_ddlph: '导轮动平衡',
    txt_dphhh: '动平衡',
    txt_qt: '其他',
    txt_zhqs: '转化趋势',
    txt_ltxl: '轮胎销量',
    txt_ltfw: '轮胎服务',
    txt_ckxq: '查看详情',
    txt_jt: '今天',
    txt_zt: '昨天',
    txt_bz: '本周',
    txt_by: '本月',
    txt_sy: '上月',
    txt_jn: '今年',
    txt_zhcl: '转化车辆',
    txt_zhl: '转化率',
    txt_bfb: '百分比',
    txt_abjx: '按边界状态下轮胎条数分布',
    txt_aljg: '按立即更换下轮胎条数分布',
    txt_qwpm: '按轻微偏磨下轮胎条数分布',
    txt_ayzp: '按严重偏磨下轮胎条数分布',
    txt_lingt: '0条',
    txt_yt: '1条',
    txt_et: '2条',
    txt_st: '3条',
    txt_ft: '4条',

    //机会
    txt_xsjh: '销售机会',
    txt_gzz: '跟踪中',
    txt_clwb: '处理完毕',
    txt_ckbg: '查看报告',
    txt_yxs: '已显示全部数据',
    txt_zhuiz: '追踪',
    txt_tix: '提醒',
    txt_chuli: '处理',
    txt_yzh: '已转化',
    txt_wzh: '未转化',
    txt_gzsmts: '{0}检查出现问题，预计{1}来店里维修',
    txt_czbty: '车主不同意',
    txt_yyx: '有意向',
    txt_ltyg: '轮胎1个',
    txt_ltkg: '轮胎2个',
    txt_ltsang: '轮胎3个',
    txt_ltsig: '轮胎4个',
    txt_jhcl: '机会处理',
    txt_jhztai: '机会状态',
    txt_crquy: '责任区域',
    txt_chuliry: '处理人员',
    txt_chulijg: '处理结果',
    txt_zhuanhuanr: '转化内容',
    txt_zhuanhuaje: '转化金额',
    txt_zhuanhuasj: '转化时间',
    txt_zhuanhuayx: '转化意向',
    txt_xuanzesj: '选择时间',
    txt_tsdatawk: '机会状态为空无法保存数据',
    txt_qtxzhsj: '请在转化意向栏填写预期时间',
    txt_qtxzhnr: '请填写转化内容',
    txt_qtxzhsj: '请填写转化时间',
    txt_sbts: '数据保存失败，请检查网络',


    //设备
    txt_sbgl: '设备管理',
    txt_tj: '添加',
    txt_gdssb: '共{0}个设备',
    txt_sbbh: '设备编号',
    txt_gjbb: '固件版本',
    txt_tjsj: '添加时间',
    txt_zdgx: '自动更新',
    txt_gxgj: '更新固件',
    txt_jieb: '解绑',
    txt_sbtsxx: '设备固件有新版本，点击更新固件按钮更新',
    txt_wjh: '未激活',
    txt_lix: '离线',
    txt_zaix: '在线',
    txt_guz: '故障',
    txt_yijieb: '已解绑',
    txt_yihuis: '已回收',
    txt_gxsbgj: '更新设备固件',
    txt_gxsbgjts: '确定要更新设备固件吗',
    txt_socketdk: '与服务器通讯连接未建立，请重试',
    txt_cscgts: '更新固件请求发送成功',
    txt_jbsb: '解绑设备',
    txt_jbsbts: '确定要解绑设备吗',
    txt_tscg: '操作成功',
    txt_zdgxgj: '自动更新固件',
    txt_gxgjts: '确定要{0}设备的自动更新固件功能吗?',
    txt_beiz: 'หมายเหตุ',
    txt_qtxbz: '请填写备注',
    txt_bdsbts: '本APP仅用于【手持式轮胎检测国际版】的设备，请确保您想绑定的设备型号正确',
    txt_qdksb: '请先打开设备',
    txt_dksbts1: '1、新设备，开机后将自动进入绑定引导',
    txt_dksbts2: '2、如果设备此前绑定过其他门店，请先在设备的"设置"菜单中点击解绑设备进行解绑，解绑后设备将自动进入绑定引导',
    txt_yjdksblw: '我已打开设备并联网',
    txt_xyb: '下一步',
    txt_qsclj: '请使手持式设备扫描二维码连接',
    txt_qscts1: '设备扫码成功后会发出"嘀"声提示',
    txt_qscts2: '并提示您扫码成功',
    txt_sbtssmcg: '设备已提示扫码成功',
    txt_ddsblw: '等待设备联网',
    txt_zznlbd: '正在努力为您绑定设备',
    txt_qszdd: '这可能需要花费几十秒，请稍作等待',
    txt_bdcg: '绑定成功',
    txt_tjcg: '添加成功',
    txt_tjcgts: '恭喜你添加成功，请填写备注名称方便你辨认设备',
    txt_fhsblb: '返回设备列表',
    txt_jxtjsb: '继续添加设备',
    txt_bzmc: '备注名称',


    //检测记录
    txt_sx: '筛选',
    txt_khsj: '客户手机',
    txt_cphm: 'เลขทะเบียน',
    txt_cphm1: 'เลขทะเบียน',
    txt_clxh: '车辆型号',
    txt_xgbz: '修改备注',
    txt_gtfjl: '共 {0} 份记录',
    txt_jcsj: 'ตรวจสอบเวลา',
    txt_jcsj1: 'ตรวจสอบเวลา',
    txt_xzkssj: '选择开始时间',
    txt_xzjssj: '选择结束时间',
    txt_jcjg: 'ผลการทดสอบ',
    txt_msqk: 'สภาพใช้งานดอกยาง',
    txt_jygh: 'แนะนำให้เปลี่ยน',
    txt_zysh: 'สังเกตการสูญเสีย',
    txt_zcsy: 'ใช้ได้ปกติ',
    txt_zc: 'ปกติ',
    txt_cz: 'ตั้งค่าใหม่',
    txt_qd: 'แน่ใจ',
    txt_jcjgd: 'ผลการตรวจสอบ',
    txt_msqkd: 'การสึกหรอ',
    txt_sldwd: 'ตำแหน่งสี่ล้อ',
    txt_jyghd: 'แนะนำให้เปลี่ยน',
    txt_zysh: 'สังเกตการสูญเสีย',
    txt_zcsyd: 'ใช้ปกติ',
    txt_xdwd: 'จำเป็นต้องมีการจัดตำแหน่ง:',
    txt_xzyd: 'ต้องใส่ใจ',
    txt_zcd: 'ปกติ',
    txt_bgxq: 'รายละเอียดรายงาน',
    txt_ljdy: '连接打印',
    txt_fwmd: 'ร้านค้าบริการ',
    txt_mddz: 'ที่อยู่ร้าน',
    txt_jcsb: 'อุปกรณ์ตรวจจับ',
    txt_ddmd: 'ไปที่จัดเก็บ',
    txt_lic: 'ระยะเป็นไมล์',
    txt_chex: 'ประเภทรถ',
    txt_jcjyi: 'คำแนะนำการตรวจสอบ',
    txt_ysbs: 'การแสดงตัวสี',
    txt_ztms: 'การใส่โดยรวม',
    txt_hwms: 'สวมใส่ไม่เท่ากัน',
    txt_dqscjltx: 'แจ้งเตือนระยะห่างเบรคปัจจุบัน',
    txt_bgxqts: ' 备注：该测试由独立测试中心天津汽车检测中心进行，所用车辆为奥迪品牌FV7203BECGB型乘用车，轮胎规格为：245/40 R18,轮胎充气压力为：前胎230kpa，后胎220kpa；测试场地为：卡达克盐城测试地；所计算的车辆制动距离的速度范围:从100公里/小时减速至0公里/小时。',
    txt_wxsmgz: 'กวาดจดหมายไป ที่หมายเลขสาธารณะ',
    txt_hwmsjh: 'ลายดอกดูไม่เท่ากัน',
    txt_zqlun: 'ล้อหน้าด้านซ้าย',
    txt_zhlun: 'ล้อหลังด้านซ้าย',
    txt_yqlun: 'ล้อหน้าด้านขวา',
    txt_yhlun: 'ล้อหลังด้านขวา',
    txt_pingjunzhi: 'ค่าเฉลี่ย',
    txt_guige: 'ขนาด',
    txt_gongli: 'ระยะไมล์',
    txt_ltwjc: 'ยางไม่ได้ตรวจสอบ',
    txt_pinpai: 'ยี่ห้อ',
    txt_ltws: 'รูปลักษณ์ยางรถ',
    txt_sewmts: 'สแกน QR Code เพื่อตรวจสอบรายงาน',
    txt_print: 'Print',





    //店员管理
    txt_xz: '新增',
    txt_qy: '启用',
    txt_qyz: '启用中',
    txt_ty: '停用',
    txt_yhzh: '用户账号',
    txt_lxfs: 'รายละเอียดการติดต่อ',
    txt_cjsj: '创建时间',
    txt_bjxx: '编辑信息',
    txt_xgmm: '修改密码',
    txt_bgzt: '变更状态',
    txt_qdytjm: '确定要将账号{0}{1}吗？',
    txt_tjdy: '添加店员',
    txt_bjdyxx: '编辑店员信息',
    txt_zhxx: '账号信息',
    txt_ygxm: '员工姓名',
    txt_qtxygxm: '请填写员工姓名',
    txt_lxdh: '联系电话',
    txt_qtxyglxdh: '请填写员工联系电话',
    txt_dxyzm: '短信验证码',
    txt_qtxdxyzm: '请填写短信验证码',
    txt_fsdx: '发送短信',
    txt_tjzh: '添加账号',
    txt_baocun: '保存',
    txt_gtgygzh: '共{0}个员工账号',



    //登录
    txt_qdytcdlm: '确定要退出登录吗',
    txt_qx: '取消',
    txt_dl: '登录',
    txt_qsrzh: '请输入账号ID（商户号请输入注册手机号）',
    txt_qsrmm: '请输入密码',
    txt_zcshzh: '注册商户账号',
    txt_shzhwjmm: '商户账号忘记密码',
    txt_yzdqmm: '验证当前密码',
    txt_szxmm: '设置新密码',
    txt_xgcg: '修改成功',
    txt_qtxjmm: '请填写旧密码',
    txt_yzzcsj: '验证注册手机',
    txt_qtxxmm: '请填写新密码',
    txt_qzctxxmm: '请再次填写新密码',
    txt_lcmmsrbyz: '两次密码输入不一致',
    txt_gxnxgcg: '恭喜你，修改成功',
    txt_qljndxmm: '请牢记你的新密码',
    txt_fhgrzx: '返回个人中心',
    txt_fsyzm: '发送验证码',
    txt_qtxzcsjh: '请填写注册手机号',
    txt_qtxtxyzm: '请填写图形验证码',
    txt_qsryzm: '请输入验证码',
    txt_qszhhmm: '请设置6-18位数字、字母组成的密码',
    txt_qzcsrmm: '请再次输入密码',
    txt_lcmmbyz: '两次密码输入不一致',
    txt_hdsy: '去首页',
    txt_zcshh: '注册商户号',
    txt_fhdl: '返回登录',
    txt_wlqqsb: '网络请求失败，请重试',
    txt_wczc: '完成注册',
    txt_wsts: ' 开始之前，完善您的商户信息吧',
    txt_qtxshmc: '请填写商户名称',
    txt_shmc: '商户名称',
    txt_rgszjd: '如公司座机、其他电话、传真等',
    txt_qtlxfs: '其他联系方式',
    txt_kssy: '开始使用',
    txt_Pwear1: '偏磨',
    txt_open: '打开',
    txt_close: '关闭',
    txt_srczhdmm: '输入重置后的密码',
    txt_kcfs: '{0}后可重发',
    txt_xiugai: '修改',
    txt_zzjzsj: '正在加载数据',
    txt_bjshxx: '编辑商户信息',
    txt_chongxinhq: '重新获取',
    txt_gaibangsj: '改绑手机',
    txt_yanzhengjsj: '验证旧手机',
    txt_bangdingxsj: '绑定新手机',
    txt_yhqsyxsjdl: '以后请您使用新手机号登录',



    //登录新
    txt_xzshenfen: '请选择您的身份',
    txt_dlrolewz: '登录{0}号',
    txt_qsrsjh: '请输入手机号',
    txt_zhuce: '注册',
    txt_wanjimima: '忘记密码',
    txt_wanshandzxx: '完善店长号资料',
    txt_qsrxm: '请输入姓名',
    txt_qsrmdm: '请输入门店名',
    txt_qsrmdgddh: '请输入门店固定电话',
    txt_qsrmddz: '请输入门店地址',
    txt_qsrgsdz: '请输入公司地址',
    txt_qsrxxdz: '请输入详细地址',
    txt_tijiaocg: '提交成功',
    txt_qsvbsylwmm: '请设置不少于6位密码',
    txt_zhucerole: '注册{0}号',
    txt_qsrshh: '请输入商户号',
    txt_qsrdzh: '请输入店长号',
    txt_wsshhzl: '完善商户号资料',
    txt_wsdyhzl: '完善店员号资料',
    txt_qsrshm: '请输入商户名(公司名称)',
    txt_qsrshz: '请输入商户主(负责人)',
    txt_qsrzrqy: '请输入责任区域(工作部门)',
    txt_shanghudizhi: '商户地址',
    txt_yhycz: '用户已存在',
    txt_qsrzqdzh: '请输入正确店长号',
    txt_qsrzqshh: '请输入正确商户号',
    txt_xzmdcx: '选择门店查询',



    //门店
    txt_mendianId: '门店ID',
    txt_mendianmc: '门店名称',
    txt_mendiandz: '门店地址',
    txt_mendiandh: '门店电话',
    txt_caozuo: '操作',
    txt_mendiangl: '门店管理',
    txt_gjmendian: '共 {0} 家门店',
    txt_zhengchangyy: '正常营业',
    txt_tingye: '停业',
    txt_gengdxx: '更多信息',
    txt_dianygl: '店员管理',
    txt_biangzt: '变更状态',
    txt_qdygbzhuangtai: '确定要将门店{0}状态变更为{1} 吗？',
    txt_bjmendian: '编辑门店信息',
    txt_xinzenmd: '新增门店',
    txt_qtxmdmc: '请填写门店名称',
    txt_qxzmddz: '请选择门店地址',
    txt_qtxxdz: '请填写详细地址',
    txt_xiangxidz: '详细地址',
    txt_qtxmddh: '请填写门店电话',
    txt_dzxx: '店长信息',
    txt_chaungjianmendian: '创建门店',
    txt_mendianxxxx: '门店详细信息',
    txt_bianji: '编辑',
    txt_mendianzt: '门店状态',

    //商户数据总览
    txt_mendianshuju: '门店数据',
    txt_chakangdxxbb: '查看更多详细报表',
    txt_jczcs: '检测总次数',
    txt_mdpjjc: '门店平均检测',
    txt_jdzcl: '进店总车辆',
    txt_jcl: '检测率',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: '今日总览',
    txt_xiangqbb: '详情报表',
    txt_xuanzerqckxxsj: '选择日期查看详细数据',
    txt_qxzsjd: '请选择时间段',
    txt_sjdts: '最多只能选择30天以内的时间段',
    txt_zonglan: '总览',
    txt_qushi: '趋势',
    txt_shuliangtj: '数量统计',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: '检测次数趋势',
    txt_msqkslqs: '轮胎磨损情况数量趋势',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: '检测次数',
    txt_shuliang: '数量',
    txt_zhanbi: '占比',
    txt_chankangd: '查看更多',
    txt_chakanmdxxbb: '查看门店详细报表',


    //国家
    txt_zhongguo: '中国',
    txt_mlxy: '马来西亚',
    txt_yindu: '印度',
    txt_taiguo: '泰国',
    txt_oluosi: '俄罗斯',



    txt_taici: 'รถ',
    txt_jianyi: 'คำแนะนำ:',
    txt_jianyineirong: 'ยางสึกไม่เท่ากัน แนะนำให้ตรวจสอบเพิ่มเติม',
    txt_jianyineirongzc: 'ปกติ',
    txt_bgtixing: 'เตือนความจำ:',
    txt_bgtuxubfnr: 'ตามการสึกหรอของยาง ระยะเบรกเพิ่มขึ้น 0% (ค่าโดยประมาณ)',
    txt_waishang: 'ความเสียหาย',
    txt_laohua: 'อายุ',
    txt_gubao: 'นูน',
    txt_xichemeirong: 'ล้างรถและเก็บรายละเอียด',
    txt_weixiubaoyang: 'ซ่อมบำรุง',
    txt_guenghuanluntai: 'เปลี่ยนยาง',
    txt_scsltjcy: 'เครื่องตรวจจับยางแบบพกพา',
    txt_shijiantishi: 'เวลาสิ้นสุดต้องมากกว่าเวลาเริ่มต้น',

    txt_qxzclry: 'โปรดเลือกตัวประมวลผล',
    txt_lf_outworn: 'ยางหน้าซ้ายด้านนอกสึกหรอมากกว่าด้านใน',
    txt_lf_innerworn: 'ยางหน้าซ้ายด้านในสึกหรอมากกว่าด้านนอก',
    txt_lf_bothsideworn: 'ยางหน้าซ้ายทั้งสองข้างสึกมากกว่าตรงกลาง',
    txt_lf_centreworn: 'ตรงกลางของยางด้านหน้าซ้ายมีการสึกหรอทั้งสองด้าน',
    txt_lb_outworn: 'ยางหลังซ้ายด้านนอกสึกมากกว่าด้านใน',       
    txt_lb_innerworn: 'ยางหลังซ้ายด้านในสึกหรอมากกว่าด้านนอก',        
    txt_lb_bothsideworn: 'ยางหลังซ้ายทั้งสองข้างสึกหรอมากกว่าตรงกลาง',        
    txt_lb_centreworn: 'ตรงกลางของยางด้านหลังซ้ายสึกหรอกมากกว่าด้านข้างทั้งสอง',        
    txt_rb_outworn: 'ยางด้านหลังด้านขวามีการสึกหรอมากกว่า ด้านใน',         
    txt_rb_innerworn: 'ยางล้อหลังข้างขวาด้านนอกสึกหรอมากกว่าด้านใน',        
    txt_rb_bothsideworn: 'ยางหลังด้านขวาทั้งสองข้างสึกหรอมากกว่าตรงกลาง',         
    txt_rb_centreworn: 'ตรงกลางของยางด้านขวามีการสึกหรอทั้งสองด้าน',        
    txt_rf_outworn: 'ยางหน้าขวาด้านนอกสึกหรอมากกว่าด้านใน',         
    txt_rf_innerworn: 'ด้านในของยางหน้าขวาสึกหรอมากกว่าด้านนอก',        
    txt_rf_bothsideworn: 'ยางหน้าด้านขวาทั้งสองด้านสึกหรอมากกว่าตรงกลาง',       
    txt_rf_centreworn: 'ตรงกลางของยางด้านหน้าขวามีการสึกหรอทั้งสองด้าน',  
    txt_tire_need_replace: 'มีการเสื่อมสภาพของยาง ที่จำเป็นต้องเปลี่ยนใหม่ทันที',

    txt_alignment_chassis: 'ขอแนะนำให้ดำเนินการกำหนดตำแหน่งล้อ 4 ล้อเพิ่มเติมหรือการตรวจจับแชสซีต่อไป',

    txt_do_further_check: 'โปรดตรวจสอบเพิ่มเติม',
    txt_uneven_check:'ยางเสื่อมสภาพผิดปกติแนะนำให้เคลื่อน ที่สมดุล และตำแหน่งสี่ล้อเพื่อตรวจสอบระบบล้อระบบ',
    txt_tire_rotation: 'แนะนำให้เปลี่ยนยาง',           
    txt_wear_normal: 'การสึกหรอของยางปกติ',   
    'txt_wear_normal;': 'การสึกหรอของยางปกติ',     
    txt_tire: 'ยางรถ',
    txt_xiazai: 'ดาวน์โหลด',
    txt_xiazaishibai: 'การดาวน์โหลดล้มเหลว',
    txt_appname: 'Leadshub',
    txt_dianjixiazaiandroid: '点击下载Android',
    txt_dianjixiazaiios: '点击下载Ios',






    txt_gelie: 'รอยแยก',
    txt_diaokuai: 'วางบล็อค',
    txt_chaungci: 'เจาะรู',
    txt_cashang: 'รอยขีดข่วน',
    txt_yichang: 'ยางผิดปกติ',
    txt_qjybjcltazqk: 'โปรดตรวจสอบปัญหาการติดตั้งยาง',
    txt_wear_overall: 'การสึกหรอโดยรวม',
    txt_pattern_wear: 'การสึกหรออย่างผิดปกติ',
    txt_tire_age: 'อายุยางรถ',
    txt_tire_appearance: 'ลักษณะของยาง',
    txt_tire_age_5:'ยางใช้มานานกว่า 5 ปี ขอแนะนำให้ตรวจสอบยางอย่างละเอียดและเปลี่ยนหากจำเป็น',
    txt_tire_age_8:'ยางหมดอายุเกิน 8 ปีแนะนำให้เปลี่ยนยาง',
    txt_tire_age_6:'ยางหมดอายุนานกว่า 6 ปีให้ตรวจสอบเป็นประจำ',
    txt_tire_age_3:'ยางใช้งานมามากกว่า 3 ปี แนะนำให้ตรวจเช็คตามระยะ',
    txt_tire_age_ok: 'อายุยางรถดี',
    txt_tire_trauma_check: 'ยางมีความเสียหาย กรุณาตรวจสอบเพิ่มเติม',
    txt_install_abnormal_check: 'การติดตั้งยางผิดปกติ กรุณายืนยัน',
    txt_tire_appearance_ok: 'ลักษณะยางโอเค',
    txt_ltlcgstm: 'จากการสึกหรอของยางในปัจจุบัน ระยะการแล่นของยางคือ {0}กม. (ค่าโดยประมาณ)',
    'txt_tire_need_replace;': 'ยางสึกหรอหนัก แนะนำให้เปลี่ยน.',
    'txt_uneven_check;': 'ยางเสื่อมสภาพผิดปกติแนะนำให้เคลื่อน ที่สมดุล และตำแหน่งสี่ล้อเพื่อตรวจสอบระบบล้อระบบ',
    txt_tire_rotation: 'แนะนำให้เปลี่ยนยาง',
    'txt_tire_age_ok': 'อายุยางรถดี',
    'txt_wear_uniform;': 'แต่ละล้อมีการสึกหรอเท่ากัน',    
    txt_wear_uniform: 'แต่ละล้อมีการสึกหรอเท่ากัน',    
    'txt_tire_boundary;': 'มีรอยล้อรถ ที่ขอบเขต',     
    txt_tire_boundary: 'สถานะการสึกหรอของยาง: บริเวณขอบ', 
    txt_plcl: '批量处理',
    txt_qbxz: '全选',
    txt_scjcjg: 'ผลการตรวจสอบล่าสุด',
    txt_ltxhlcgs: 'การประมาณระยะยาง',
    txt_ltazhuang: 'ติดตั้งยางรถ:',
    txt_dqltlctx: 'ยางปัจจุบันถึงขีดจำกัด กรุณาเปลี่ยนยางทันที',
    txt_dottx: 'การประมาณอายุของยาง',
    txt_danweinian: '(หน่วย: ปี)',
    txt_danweikm: '(หน่วย: กิโลเมตร)',
    txt_myhqdsj: 'ยังไม่ถึงเวลา',
    txt_dotjstx: 'ระยะเวลาการใช้งานยางที่เหลืออยู่ประมาณ {0} วัน',
    txt_dotjstx2: 'ยางใช้งานมาเกิน 5 ปีแล้ว กรุณาเปลี่ยนทันที',
    txt_dotsjztx: '(DOT: วัน ที่ผลิตยาง)',
    'txt_tire_age_ok;': 'อายุยางโอเค',


    //微信公众号
    txt_mdmz: '门店姓名',
    txt_mddzz: '门店地址',
    txt_sbid: '设备ID',
    txt_jsxm: '技师姓名',
    txt_shoujhm: '手机号码',
    txt_dxyzmm: '短信验证码',


    txt_jishimz: 'ชื่อพนักงาน',
    txt_ltlcgsnew: 'ระยะยางคงเหลือ',
    txt_ltlcgsnewin: 'ช่วงยางคือ {0} ไมล์',
    txt_pinnate_wear: 'การสึกหรอของสี',
    txt_msjxtx: 'ยางถึงขีดจำกัด กรุณาเปลี่ยนทันที',
    txt_ltfz: 'ด้านในและด้านนอก',
    txt_install_check: 'ตรวจสอบการติดตั้ง',
    txt_install_ok: 'ติดตั้งปกติ',
    LF: '[ล้อหน้าด้านซ้าย]',
    RF: '[ล้อหน้าด้านขวา]',
    LB: '[ล้อหลังด้านซ้าย]',
    RB: '[ล้อหลังด้านขวา]',
    FF: '[แกนด้านหน้า]',
    BB: '[แกนด้านหลัง]',
    txt_appearance_check:'ยางมีความเสียหาย กรุณาตรวจสอบเพิ่มเติม',
    txt_uneven_center:'การสึกหรอของยางผิดปกติ ขอแนะนำให้ตรวจสอบแรงดันลมยาง',
    txt_uneven_out: 'การสึกหรอผิดปกติที่ด้านนอกของยาง ขอแนะนำให้ตรวจสอบการจัดตำแหน่งล้อสี่ล้อและแรงดันลมยาง',
    txt_pinnate_check: 'ยางมีการสึกหรอเล็กน้อย ขอแนะนำให้ทำการตรวจสอบระบบกันสะเทือนเพิ่มเติม',
    txt_uneven_inside: 'การสึกหรอผิดปกติที่ด้านในของยาง ขอแนะนำให้ตรวจสอบการจัดตำแหน่งล้อสี่ล้อและแรงดันลมยาง',
    'txt_do_further_check;': 'กรุณาตรวจสอบเพิ่มเติม',
    txt_uneven_bothside: 'การสึกหรอผิดปกติของยางทั้งสองด้าน ขอแนะนำให้ตรวจสอบการจัดตำแหน่งล้อสี่ล้อและแรงดันลมยาง',

    txt_msyzljgh: 'ยางเสื่อมสภาพ กรุณาเปลี่ยนทันที',
    txt_serious_trauma_check:"ยางมีความเสียหายร้ายแรง ขอแนะนำให้เปลี่ยนยาง",
    txt_appearance_lookup:"โปรดตรวจสอบลักษณะของยาง",
    txt_wear_lookup :"โปรดตรวจสอบการสึกหรอของยาง",
    txt_dotscsj: 'อายุยาง',
    txt_whqdscsj: 'ไม่มีวันที่ผลิต',
    purp_tireservice: 'บริการยาง',
    purp_vehicle_inspection: 'เช็ครถ',

    txt_qiao: 'สะพาน',
    txt_left: 'ซ้าย',
    txt_right: 'ขวา',
    txt_lun: 'ยางรถ',
    txt_huawen: 'ดอกยาง',
    txt_taihao: 'หมายเลขยาง',
    txt_taiya: 'แรงดันลมยาง',
    txt_chexlw: 'ตำแหน่งล้อ',
    txt_jiancerenyuan: 'เครื่องตรวจจับ',
    txt_beitai:'ยางอะไหล่',
    txt_tuoche:'รถแทรกเตอร์',
    txt_guache:'รถพ่วง',
    txt_chassis_check: 'การตรวจสอบแชสซี',
    txt_chassis_ok: 'แชสซีโอเค',
    txt_chassis_oil: 'โช้คอัพมีน้ำมันรั่วแนะนำให้ตรวจสอบเพิ่มเติมและเปลี่ยนถ้าจำเป็น',
    txt_chassis_aging: 'อายุยางของหัวเพลาเก่าแนะนำให้เปลี่ยน',
    txt_chassis_more: 'รถมีอายุการใช้งานของยางหัวเพลาและการรั่วไหลของน้ำมันผิดปกติของโช้คอัพ และขอแนะนำให้ซ่อมแซม',
    chassis_oil:'โช๊คอัพน้ำมันรั่ว',
    chassis_aging:'อายุยางของหัวเพลา',
    chassis_normal:'ผิดปกติ',
    
    // new add  wu
    txt_lights:'ไฟ',
    txt_high_beam:'ไฟสูง',
    txt_low_beam:'ไฟต่ำ',
    txt_daytime:'ไฟกลางวัน',
    txt_fog_light:'ไฟตัดหมอก',
    txt_brake_light:'ไฟเบรค',
    txt_turn_signals:'ไฟเลี้ยว',
    txt_backup_lights:'ไฟสำรอง',
    txt_hazards:'ไฟเตือน',

    txt_glass:'กระจก',
    txt_windshield:'กระจกหน้ารถ',
    txt_back_glass:'กระจกมองหลัง',
    txt_right_side_windows:'กระจกข้างขวา',
    txt_left_side_windows:'กระจกข้างซ้าย',
    txt_wipers_front:'ที่ปัดน้ำฝนด้านหน้า',
    txt_wipers_rear:'ที่ปัดน้ำฝนด้านหลัง',

    txt_under_hood:'ฝาครอบเครื่องรถยนตร์',
    txt_horn:'แตร',
    txt_oil_level:'ระดับน้ำมัน',
    txt_air_filter:'กรองอากาศ',
    txt_trans_fluid:'น้ำมันเครื่อง',

    txt_coolant_level:'ระดับน้ำหล่อเย็น',
    txt_power_steering_fluid:'น้ำมันพวงมาลัยเพาเวอร์',
    txt_windshield_washer_fluid:'น้ำปัดน้ำฝน',
    txt_belts:'เข็มขัด',
    txt_hoses:'สายยาง',
    txt_ac_system:'ระบบปรับอากาศ',
    txt_battery:'แบตเตอรี่',

    txt_under_vehicle:'แชสซี',
    txt_suspension:'ช่วงล่าง',
    txt_exhaust:'ท่อไอเสีย',
    txt_brake_lines:'สายเบรค',
    txt_oil_drain_plug:'ปลั๊กถ่ายน้ำมันเครื่อง',
    txt_differential:'ความแตกต่าง',

    txt_brakes:'เบรค',
    txt_front_left:'เบรคหน้าซ้าย',
    txt_front_right:'เบรคหน้าขวา',
    txt_rear_left:'เบรคหลังซ้าย',
    txt_rear_right:'เบรคหลังขวา',
    txt_parking_brake:'เบรกจอดรถ',
    txt_spare_pressure:'แรงดันลมยางอะไหล่',
      
    txt_interior:'ภายใน',
    txt_cabin_fiter:'ไส้กรองแอร์',
    txt_heating:'อุปกรณ์ทำความร้อน',
    txt_AC_system:'ระบบปรับอากาศ',
    txt_interior_lights:'ไฟภายใน',
    txt_front_defrost:'ละลายน้ำแข็งด้านหน้า',
    txt_rear_defrost:'ละลายน้ำแข็งด้านหลัง',

    txt_tire_pressure:'แรงดันลมยาง',
    txt_left_front:'แรงดันลมยางหน้าซ้าย',
    txt_right_front:'แรงดันลมยางหน้าขวา',
    txt_left_rear:'แรงดันลมยางหลังซ้าย',
    txt_right_rear:'แรงดันลมยางหลังขวา',
    

    
    txt_null:'',
    //cormach
    txt_hood:'ฝาครอบเครื่องรถยนตร์',
    txt_wash_liquid:'น้ำปัดน้ำฝน',
    txt_level_control:' การควบคุมระดับ',
    txt_haoxiaoxi:'OK',
    txt_vedi_Note:'โปรดดูคู่มือ ',
    txt_replace1:'แทนที่',
    txt_radiator_fluid:'น้ำยาหม้อน้ำ',
    txt_engine_oil:'น้ำมันเครื่อง',
    txt_brake_fluid:'น้ำมันเบรค',
    txt_quality_control:'การควบคุมคุณภาพ',
    txt_multimeter:'การทดสอบมัลติมิเตอร์',
    txt_subtotal:'จำนวน',
    txt_shock_absorber:'โช้คอัพ',
    txt_check_loss:' ตรวจสอบความเสียหายที่มองเห็นได้',
    txt_brake_disc:' จานเบรค',
    txt_wear_condition:'สภาพการสึกหรอ',
    txt_brake_pads:'ผ้าเบรค',

    txt_change_control:'การเปลี่ยนแปลงการควบคุม',
    txt_air_control:'ระบบปรับอากาศ',
    txt_last_reload:'รีโหลดล่าสุด',
    txt_lighting:'แสงสว่าง',
    txt_verification1:'ที่ปัดน้ำฝน',
    txt_dynamometer:'การปรับไดนาโมมิเตอร์',
    txt_batteria:'แบตเตอรี่',
    txt_verification:'กำลังดำเนินการตรวจสอบ',
    txt_levellow:'ปกติ',
    txt_levelmiddle:'ตารางงาน',
    txt_levelhigh:'แทนที่',
    txt_tyrenumber:'สแกนความลึก',
    txt_cormach_title:'สวมใส่และสวมใส่ไม่สม่ำเสมอ',
    txt_wearlow:'ลายดอกดูไม่เท่ากัน',
    txt_wearmiddle:'สึกหรอเล็กน้อย',
    txt_wearhigh:'สึกหรอรุนแรง',
    txt_namtishi:'ความลึกของยาง 32 องศา',
    txt_zhiliangkongzhi:'ควบคุมคุณภาพ',
    txt_buchongzhengduan:'การวินิจฉัยเพิ่มเติม',
    txt_season_summer:'ยางฤดูร้อน',
    txt_season_winter:'ยางฤดูหนาว',
   


    txt_khxm:'ชื่อลูกค้า',
    txt_khyx:'เมล์ลูกค้า',
   
    txt_tire_season: 'ยางเต็มฤดู',
    txt_tire_other: 'ยางอื่น ๆ',
    txt_bolt: 'สลักเกลียว',
    txt_goods_name: 'ชื่อสินค้า',
    txt_yes: 'ครับ',
    txt_no: 'ไม่',  
}



// WEBPACK FOOTER //
// ./src/i18n/thai.js